<div *ngIf="boardingPasses" class="modal modal-container" tabindex="-1" role="dialog" #modal focusElement>
  <div class="modal-dialog" role="document" trapFocus>
    <div class="modal-content">
      <div class="modal-header-ua">
        <div class="header-icon">
          <img alt="united" src="./../../../assets/united-logo.svg" />
        </div>
        <button class="close-icon unstyle-button" (click)="closeModal()"><img alt="close" src="../../../assets/close-black.svg" /></button>
      </div>
      <div *ngIf="boardingPasses[index]" class="modal-body{{index < activeSegmentIndex ? ' backdrop' : ''}}">
        <div class="segment-detail">
          <span>{{boardingPasses[index].origin | uppercase}}</span>
          <img class="flight-icon" src="../../../assets/flight-icon-black.svg" alt = "close-icon"/>
          <span> {{boardingPasses[index].destination | uppercase}}</span>
        </div>
        <div class="travel-ready" *ngIf="boardingPasses[index]?.passengerList.isTravelReady === 'true'">
          <span class="badge">{{pageConstants.travelReady}}</span> 
        </div>
        <div class="bar-code-wrapper">
          <div class="chevron chevron-left">
            <button [class]="{'hidden': index === 0}" (click)="index = index - 1"
              class="material-icons-round unstyle-button">arrow_back_ios</button>
          </div>
          <div class="boarding-pass" >
            <img
              src="data:image/jpeg;base64,{{boardingPasses[index].passengerList?.bpImages[0]}}" alt="boarding pass here"
            />
          </div>
          <div class="right-container"> 
            <div class="chevron chevron-right">
              <button  (click)="index = index + 1" [class]="{'hidden': index >= boardingPasses.length-1 }" class="material-icons-round unstyle-button">arrow_forward_ios</button>
            </div>
            <div *ngIf="boardingPasses.length > 1" class="page">
              <span>{{index + 1}} of {{boardingPasses.length}}</span>
            </div>
          </div>
        </div>

        <div class="customer-info">
          <span>{{boardingPasses[index].passengerList.firstName}} {{boardingPasses[index].passengerList.lastName}}</span>
        </div>
        <div class="boarding-group" *ngIf="boardingPasses[index]?.passengerList?.bpGroupNumber">
          <span>Boarding group: {{boardingPasses[index].passengerList.bpGroupNumber}}</span>
        </div>
        <div class="sequence" *ngIf="boardingPasses[index]?.passengerList?.sequenceNumber">
          <span>Sequence: {{boardingPasses[index].passengerList.sequenceNumber}}</span>
        </div> 
      </div>
    </div>
  </div>
</div>
